import { render } from "./ZohoSalesIQ.vue?vue&type=template&id=3fbbb410&scoped=true"
import script from "./ZohoSalesIQ.vue?vue&type=script&lang=js"
export * from "./ZohoSalesIQ.vue?vue&type=script&lang=js"

import "./ZohoSalesIQ.vue?vue&type=style&index=0&id=3fbbb410&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fbbb410"]])

export default __exports__